/**
* Dashboard
* @namespace gplans.dashboard.services
*/
(function () {
  'use strict';
  angular.
  module('gplans.dashboard.services');
})();